var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitterWeightBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.65,
    y: 46.02,
    width: 453.13,
    height: 453.13,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_weight_box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72",
    "data-name": "Layer 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.32,140.59V511.16A20.11,20.11,0,0,1,580,531H171.24a20.12,20.12,0,0,1-20.36-19.87V22.42A20.12,20.12,0,0,1,171.24,2.55H458.88a20.79,20.79,0,0,1,6.9,1.17L598.49,132.36A19.36,19.36,0,0,1,600.32,140.59Z",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.15,130.31H486a20.37,20.37,0,0,1-20.58-20.15V1.67Z",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.06,
    y: 11.58,
    width: 527.26,
    height: 527.26,
    rx: 43.37,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,21.58A33.37,33.37,0,0,1,580.32,55V495.47A33.37,33.37,0,0,1,547,528.84H106.43a33.37,33.37,0,0,1-33.37-33.37V55a33.37,33.37,0,0,1,33.37-33.37H547m0-20H106.43A53.43,53.43,0,0,0,53.06,55V495.47a53.43,53.43,0,0,0,53.37,53.37H547a53.43,53.43,0,0,0,53.37-53.37V55A53.43,53.43,0,0,0,547,1.58Z",
    fill: "#ffdc8d"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "128.69 352.33 245.67 300.33 412.33 135.81 562.12 62.28",
    fill: "none",
    stroke: "#00b2db",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.17 319 248.38 213.87 401.73 220.23 584.58 101.98",
    fill: "none",
    stroke: "#ff7bac",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "174.9 452.39 255 334.39 400.33 284.33 597.79 160.66",
    fill: "none",
    stroke: "#a97fed",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 300.58,
    width: 298.14,
    height: 298.14,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.27,403.17,268.86,586.52A14.25,14.25,0,0,1,255,598.59H48.84A14.24,14.24,0,0,1,35,586.52l-6.19-36.14-5-29L3.57,403.17a14.66,14.66,0,0,1,9.67-16.52,446.69,446.69,0,0,1,54.33-13.87h.06c9.43-1.79,19.44-3.38,30-4.65l.19,0A450.76,450.76,0,0,1,146,364.9H146l3.65,0h5.81a450.75,450.75,0,0,1,46.86,2.8l.2,0c10.53,1.19,20.55,2.69,30,4.4h.07a447.75,447.75,0,0,1,58,14.55A14.67,14.67,0,0,1,300.27,403.17Z",
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,385.08a83.41,83.41,0,0,1-83.41,83.41h-.48a83.41,83.41,0,0,1-82.94-83.41,84.83,84.83,0,0,1,.84-11.9l.06-.41a83.43,83.43,0,0,1,82-71.09h.48a83.44,83.44,0,0,1,82.4,70.42c0,.15,0,.29.07.43A83.92,83.92,0,0,1,233.56,385.08Z",
    fill: "#7effaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "meter"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150.14,
    cy: 385.08,
    r: 55.02,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.49,374.39a11.24,11.24,0,0,0-4.7-1h-.12a11.23,11.23,0,0,0-4.43.95,11.35,11.35,0,0,0,4.43,21.76h.12a11.35,11.35,0,0,0,4.7-21.69Zm-4.7,15.31h-.12a5,5,0,0,1,0-9.94h.12a5,5,0,0,1,0,9.94Z",
    fill: "#ff75b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,349.11l-2.14,25.77a2.54,2.54,0,0,0,2.53,2.75H152a2.54,2.54,0,0,0,2.53-2.75l-2.14-25.77A2.54,2.54,0,0,0,147.33,349.11Z",
    fill: "#ff75b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1_paw",
    "data-name": "1 paw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.17,577.62a19.8,19.8,0,0,1-6.75,7.44,29.51,29.51,0,0,1-11.9,4.25,82.53,82.53,0,0,1-15,.69c-4.23-.11-8.48-.23-12.72-.32a15,15,0,0,0-7.61,1.8c-1.5.82-3,1.6-4.51,2.45-2.71,1.54-5.4,3.14-8.12,4.65H56.85a12.57,12.57,0,0,1-.68-1.72A28.51,28.51,0,0,1,55,591a60.87,60.87,0,0,1,.88-15.66,115.8,115.8,0,0,1,9.79-30.51,79.18,79.18,0,0,1,9.91-16.08A41,41,0,0,1,82,522.28a21,21,0,0,1,9.68-4.42c1.17-.32,2.3-.66,3.45-.93a21.61,21.61,0,0,1,2.63-.46,25.91,25.91,0,0,1,10.08,1.16,59.84,59.84,0,0,1,14.46,6.72A113.8,113.8,0,0,1,146.84,545a79.62,79.62,0,0,1,11.75,16.25,29.42,29.42,0,0,1,3.45,9.79A10.71,10.71,0,0,1,161.17,577.62Z",
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.84,494.77a37.44,37.44,0,0,0,4.62,10.42A44.53,44.53,0,0,0,54.82,516a20.75,20.75,0,0,0,6.31,3.77,13.22,13.22,0,0,0,13.11-2.15,19.83,19.83,0,0,0,6.52-9.28,28.17,28.17,0,0,0,.9-17A25.42,25.42,0,0,0,70.32,476a30.72,30.72,0,0,0-12.54-4.81,18.43,18.43,0,0,0-7.21.26A13.21,13.21,0,0,0,41,480.15a22.37,22.37,0,0,0-.8,11.92c.08.45.17.91.28,1.36S40.72,494.33,40.84,494.77Z",
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.78,472.9c-1.35-4.89-3-8.64-6-11.7a13.57,13.57,0,0,0-10.9-4.53,15.56,15.56,0,0,0-8.11,2.89c-7.24,5.1-11.82,11.93-13.12,20.76a24.33,24.33,0,0,0,2.25,14,27.81,27.81,0,0,0,9.71,11.63,17.66,17.66,0,0,0,9.69,3.27,13.13,13.13,0,0,0,11.07-5.35,27.55,27.55,0,0,0,4.58-9.77,44.63,44.63,0,0,0,1.56-16.62C128.29,475.64,127.93,473.85,127.78,472.9Z",
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.77,517.84a18.86,18.86,0,0,0,6,9.87,13.38,13.38,0,0,0,16,1.22,31.35,31.35,0,0,0,8.38-7.31A29.8,29.8,0,0,0,168,511.27a18.14,18.14,0,0,0,.3-10.79,12.27,12.27,0,0,0-8.92-8.7,18.71,18.71,0,0,0-8.22-.31,26.73,26.73,0,0,0-13.52,6.09,18.36,18.36,0,0,0-6.57,15.1c0,1.73.36,3.46.56,5.19Z",
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.79,545.16a13.51,13.51,0,0,1-6.89,9.72,13.83,13.83,0,0,1-8,1.59,33.3,33.3,0,0,1-14.09-4.3l-5-28a25.86,25.86,0,0,1,6.08-2.6,30.48,30.48,0,0,1,9-1c4.13.23,8.05,1.25,11.29,3.89C56.76,529.86,59.26,536.86,57.79,545.16Z",
    fill: "#00d89a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterWeightBox);
export default __webpack_public_path__ + "static/media/litter_weight_box.a7a19e1715347c7be493f862bbab29b8.svg";
export { ForwardRef as ReactComponent };